import { IMobilyticsScenarioFormState } from "../View/Products/Pages/Apps/Mobilytics/SubmitMobilyticsLogic";
import {
    START_FACTOR_REPORT,
    SET_FACTOR_SCENARIOS,
    SET_FACTOR_VISIBLE,
    SET_FACTOR_LOADING_SCENARIOS,
} from "./Types";

export const startFactorReport = () => ({
    type: START_FACTOR_REPORT,
    data: null,
});

export const setFactorScenarioFormStates = (scenarios: IMobilyticsScenarioFormState[]) => ({
    type: SET_FACTOR_SCENARIOS,
    data: scenarios,
});

export const setFactorVisible = (visible: boolean) => ({
    type: SET_FACTOR_VISIBLE,
    data: visible,
});

export const setFactorLoadingScenarios = (loading: boolean) => ({
    type: SET_FACTOR_LOADING_SCENARIOS,
    data: loading,
});